import { configureStore } from '@reduxjs/toolkit';
import CashOutReducer from './features/CashOutReducer';
import ConstantReducer from './features/ConstantReducer';
import DashboardReducer from './features/DashboardReducer';

import defaultReducer from './features/DefaultReducer';
import PostManagementReducer from './features/PostManagementReducer';
import ProfileReducer from './features/ProfileReducer';
import ReportManagementReducer from './features/ReportManagementReducer';
import PostReportReducer from './features/PostReportReducer';
import SearchReducer from './features/SearchReducer';
import SoundTracksReducer from './features/SoundTracksReducer';
import StaticTextReducer from './features/StaticTextReducer';
import SubscriptionReducer from './features/SubscriptionReducer';
import UserManagementReducer from './features/UserManagementReducer';
import DonateReducer from './features/DonateReducer';
import AdminTrackReducer from './features/AdminTrackReducer';

export const store = configureStore({
  reducer: {
    default: defaultReducer,
    dashboard: DashboardReducer,
    userManagement: UserManagementReducer,
    soundTracks: SoundTracksReducer,
    adminTracks: AdminTrackReducer,
    cashOut: CashOutReducer,
    reportManagement: ReportManagementReducer,
    postReport: PostReportReducer,
    staticText: StaticTextReducer,
    postManagement: PostManagementReducer,
    constantManagement: ConstantReducer,
    profile: ProfileReducer,
    search: SearchReducer,
    subscriptions: SubscriptionReducer,
    donateHistory: DonateReducer
  },
})